const { public_path } = window._zen_env_ || {};
__webpack_public_path__ = /\/$/.test(public_path || '')
  ? public_path
  : `${public_path || ''}/`;

__webpack_nonce__ = 'webpackLoadScript';

import { getThemes } from '@/config';
import { addAllBrowserTabsLocationListener } from '@zenlayer/portal-utils';
import { setConfig } from '@zenlayer/zen-design/esm/hooks/useConfig';
import {
  addSysThemeChangeListener,
  initThemes,
} from '@zenlayer/zen-design/esm/hooks/useThemeSwitch';
import enLocale from '@zenlayer/zen-design/esm/locale/en';
import zhLocale from '@zenlayer/zen-design/esm/locale/zh';
import {
  addLocaleEventListener,
  getLocale,
  setLocale,
} from '@zenlayer/zen-intl18';
import zenPerformance from '@zenlayer/zen-performance';
import queryString from 'query-string';
import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { setupCfChallenge } from './utils/setupCfChallenge';
import { setupTooManyRequests } from './utils/setupTooManyRequests';

const runSetLocale = () => {
  const query = queryString.parse(globalThis.location.search);

  const locale = getLocale();
  if (query.lang && query.lang !== locale) {
    setLocale(query.lang === 'zh' ? 'zh' : 'en');
  }
  if (locale === 'en') {
    setConfig({ locale: enLocale, dayjs: { localeName: 'en' } });
  } else if (locale === 'zh') {
    setConfig({ locale: zhLocale, dayjs: { localeName: 'zh' } });
  }

  addLocaleEventListener((newLocale) => {
    if (newLocale !== locale) {
      location.reload();
    }
  });
};

runSetLocale();

setupCfChallenge();

setupTooManyRequests();

addAllBrowserTabsLocationListener();

initThemes({ themes: getThemes() });
addSysThemeChangeListener();

zenPerformance.init({
  application: 'console',
  sendUrl: '/api/collectApi/collect/web/performance',
});

createRoot(document.getElementById('portal') as Element).render(
  createElement(App)
);
